var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0079BF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64,
    cy: 64,
    r: 50
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.4,39.5H45.6c-3.4,0-6.1,2.7-6.1,6.1v36.7c0,3.4,2.7,6.1,6.1,6.1h36.7c3.4,0,6.1-2.7,6.1-6.1V45.6  C88.5,42.2,85.8,39.5,82.4,39.5z M60.8,77.9c0,1.6-1.3,2.9-2.9,2.9h-9.1c-1.6,0-2.9-1.3-2.9-2.9V50.1c0-1.6,1.3-2.9,2.9-2.9h9.1  c1.6,0,2.9,1.3,2.9,2.9V77.9z M82.1,65.7c0,1.6-1.3,2.9-2.9,2.9h-9.1c-1.6,0-2.9-1.3-2.9-2.9V50.1c0-1.6,1.3-2.9,2.9-2.9h9.1  c1.6,0,2.9,1.3,2.9,2.9V65.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon23);
export default __webpack_public_path__ + "static/media/icon23.3d98beb6cc7c2cba6111c32e30dbbf21.svg";
export { ForwardRef as ReactComponent };